import { preloadImage } from './utils';
import debounce from 'lodash.debounce';

export class CarouselCropped {
  constructor(Flickity) {
    this.flickity = Flickity;
    this.flickity.prototype._touchActionValue = 'pan-y pinch-zoom';
    this.carousels = document.querySelectorAll('.carousel-cropped');
    this.baseurl = document
      .querySelector('[name="cloudinary-url"]')
      .getAttribute('content');

    if ('IntersectionObserver' in window) {
      this.initObserver();
      return;
    }

    this.carousels.forEach(gallery => {
      this.initCarousel(gallery, Flickity);
    });
    return;
  }

  initObserver() {
    if (this.observer) {
      this.observer.disconnect();
    }

    const intersectionConfig = {
      threshold: 0.01,
    };

    this.observer = new IntersectionObserver(
      this.onIntersection,
      intersectionConfig,
    );

    this.observeCarousels();
  }

  observeCarousels() {
    this.count = this.carousels.length;
    this.carousels.forEach(carousel => {
      if (carousel.classList.contains('flickity-enabled')) {
        return;
      }

      this.observer.observe(carousel);
    });
  }

  onIntersection = entries => {
    entries.filter(entry => entry.intersectionRatio > 0).forEach(entry => {
      this.count--;
      this.observer.unobserve(entry.target);
      this.initCarousel(entry.target, this.flickity);
    });

    if (this.count === 0) {
      this.observer.disconnect();
    }
  };

  async initCarousel(gallery, Flickity) {
    /** @type {HTMLElement} */
    const counter = gallery.nextSibling.querySelector('.carousel-counter-current');
    const images = [...gallery.querySelectorAll('.carousel-lazy-img')];
    const height = gallery.getBoundingClientRect().height;
    const promises = images.map(async image => {
      const params = [
        `h_${100 * Math.ceil(height / 100)}`,
        'q_98',
        'f_auto',
        'b_white',
        // window.devicePixelRatio > 1.5 && 'dpr_2.0',
      ]
        .filter(Boolean)
        .join(',');
      const url = `${this.baseurl}/${params}/${image.dataset.src}`;
      await preloadImage(url);
      image.setAttribute('src', url);
    });

    await Promise.all(promises);

    const flkty = new Flickity(gallery, {
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      setGallerySize: false,
      cellSelector: '.carousel-lazy-img',
      arrowShape:
        'M73.75 1.676L71.947 0 26.25 50.11 71.951 100l1.799-1.68-44.165-48.214L73.75 1.676z',
      dragThreshold: 15,
      lazyLoad: 1,
      fullscreen: true,
    });

    window.flkty = flkty;

    setTimeout(()=>{
      flkty.resize();
    }, 150);

    window.addEventListener('resize', debounce(() => {
      flkty.exitFullscreen();
    }, 400));

    // select slide on click
    flkty.on('staticClick', (event, pointer, cellElement, cellIndex) => {
      flkty.select(cellIndex);
      if(window.innerWidth < 768){
        flkty.toggleFullscreen();
      }
      flkty.on( 'fullscreenChange', function( isFullscreen ) {
        if(!isFullscreen){
          document.querySelector('meta[name=viewport]').setAttribute('content', "width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1");
        } else {
          setTimeout(()=>{
            document.querySelector('meta[name=viewport]').setAttribute('content', "width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=90");
            flkty.flickity();
          }, 300);
        }
      });
    });

    // update gallery counter
    flkty.on('select', () => {
      counter.innerText = flkty.selectedIndex + 1;
    });
  }
}


// WEBPACK FOOTER //
// ./src/js/carousel-cropped.js